import { Component } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { AdminService } from 'src/app/services/admin/admin.service';
import { CourseService } from 'src/app/services/course/course.service';

@Component({
  selector: 'app-admin-xbookings',
  templateUrl: './admin-xbookings.component.html',
  styleUrl: './admin-xbookings.component.scss'
})
export class AdminXbookingsComponent {

  // Enquiry list variables
  enquiries: any[] = [];
  totalRecords = 0;
  pageSize = 10;
  pageNo = 1;
  firstRecord = 0;
  isLoading = false;
  errorMessage = '';

  // Filter variables
  selectedApprovalStatus:
    'ALL' | 'APPROVED' | 'PENDING' =
    'ALL';

  selectedActiveStatus:
    'ALL' | 'ACTIVE' | 'INACTIVE' =
    'ALL';

  // Enquiry details modal variables
  showDetailsModal = false;
  selectedEnquiry: any = null;
  selectedEnquiryBody: any = null;

  // Approval variables
  isApprovingEnquiry = false;
  approvalSuccessMessage = '';
  approvalErrorMessage = '';

  // Registration modal variables
  showRegistrationModal = false;
  selectedRegistration: any = null;
  selectedRegistrationEnquiry: any = null;
  selectedEmail: string = '';
  selectedEnquiryType: string = "";


  // Approval popup
  showApprovalPopup = false;
  showEditDatePopup = false;

  approvalTrainingDate: string = '';

  approvalDateError: string = '';

  editDatePopup: boolean = false;
  //store   prefix
  ReferencePrefix: string = '';

  todayDate: string = new Date().toISOString().split('T')[0];

  //store enq id
  bookId: number = 0;

  constructor(
    private route: ActivatedRoute,
    private adminService: AdminService,
    private sanitizer: DomSanitizer, private courseService: CourseService
  ) {
  }


  // Load enquiries on init
  ngOnInit(): void {

    this.loadEnquiries();
    this.getOrderReferencePrefix();

    // read url values

    this.route.queryParamMap.subscribe(params => {

      const id = params.get('id');

      if (id) {

        this.bookId = Number(id);

        if (this.bookId > 0) {
            this.GetXEnquiryById(this.bookId);
        }

      }

    });
  }


   //get prefix
  GetXEnquiryById(enqId: number): void {
    this.courseService.GetXEnquiryById(enqId)
      .subscribe({
        next: (enq: any) => {
          this.openEnquiryDetails(enq);
        },
        error: (error) => {
          console.error(
            'Error loading reference prefix',
            error
          );
        }
      });
  }


  //get prefix
  getOrderReferencePrefix(): void {

    this.courseService.GetReferencePrefix('BOOKING')
      .subscribe({
        next: (prefix: string) => {
          this.ReferencePrefix = prefix;
        },
        error: (error) => {
          console.error(
            'Error loading reference prefix',
            error
          );
        }
      });
  }


  // Load enquiry records
  loadEnquiries(): void {

    this.isLoading =
      true;

    this.errorMessage =
      '';

    const isApproved =
      this.getApprovalFilterValue();

    const isActive =
      this.getActiveFilterValue();

    this.adminService
      .getXEnquiryList(
        'GET_ALL_BOOK',
        this.pageNo,
        this.pageSize,
        isApproved,
        isActive,
        this.selectedEnquiryType
      )
      .subscribe({

        next: (response: any) => {

          console.log(
            'Enquiry List:',
            response
          );

          this.enquiries =
            (
              response?.records ||
              []
            )
              .map(
                (item: any) => {

                  return {

                    ...item,

                    parsedBody:
                      this.parseBody(
                        item.body
                      ),

                    parsedRegistrationBody:
                      this.parseBody(
                        item.registrationBody
                      )
                  };
                }
              );

          this.totalRecords =
            response?.totalRecords ||
            0;

          this.isLoading =
            false;
        },

        error: (error) => {

          console.error(
            'Error loading enquiries:',
            error
          );

          this.enquiries =
            [];

          this.totalRecords =
            0;

          this.isLoading =
            false;

          this.errorMessage =
            'Unable to load enquiry records.';
        }
      });
  }


  // Handle pagination
  onPageChange(
    event: any
  ): void {

    this.pageSize =
      event.rows ||
      10;

    this.firstRecord =
      event.first ||
      0;

    this.pageNo =
      Math.floor(
        this.firstRecord /
        this.pageSize
      ) + 1;

    this.loadEnquiries();
  }


  // Get approval filter
  getApprovalFilterValue():
    boolean | null {

    if (
      this.selectedApprovalStatus ===
      'APPROVED'
    ) {

      return true;
    }

    if (
      this.selectedApprovalStatus ===
      'PENDING'
    ) {

      return false;
    }

    return null;
  }


  // Get active filter
  getActiveFilterValue():
    boolean | null {

    if (
      this.selectedActiveStatus ===
      'ACTIVE'
    ) {

      return true;
    }

    if (
      this.selectedActiveStatus ===
      'INACTIVE'
    ) {

      return false;
    }

    return null;
  }


  // Apply enquiry filters
  applyFilters(): void {

    this.pageNo =
      1;

    this.firstRecord =
      0;

    this.loadEnquiries();
  }


  // Clear enquiry filters
  clearFilters(): void {

    this.selectedApprovalStatus =
      'ALL';

    this.selectedActiveStatus =
      'ALL';

    this.pageNo =
      1;

    this.firstRecord =
      0;

    this.loadEnquiries();
  }


  // Parse JSON body
  parseBody(
    body: any
  ): any {

    if (!body) {

      return null;
    }

    if (
      typeof body ===
      'object'
    ) {

      return body;
    }

    try {

      return JSON.parse(
        body
      );

    } catch (error) {

      console.error(
        'Unable to parse enquiry body:',
        error
      );

      return null;
    }
  }


  // Get enquiry client type
  getClientType(
    enquiry: any
  ): string {

    return (
      enquiry?.clientType ||
      enquiry?.parsedBody?.clientType ||
      '-'
    )
      .toString()
      .trim()
      .toUpperCase();
  }


  // Check selected enquiry is corporate
  isSelectedEnquiryCorporate(): boolean {

    const clientType =
      (
        this.selectedEnquiry
          ?.clientType ||

        this.selectedEnquiryBody
          ?.clientType ||

        ''
      )
        .toString()
        .trim()
        .toUpperCase();

    return (
      clientType ===
      'CORPORATE'
    );
  }


  // Check selected enquiry is general
  isSelectedEnquiryGeneral(): boolean {

    return (
      !this
        .isSelectedEnquiryCorporate()
    );
  }


  // Get company or course name
  getCompanyName(
    enquiry: any
  ): string {

    const clientType =
      this.getClientType(
        enquiry
      );

    if (
      clientType ===
      'CORPORATE'
    ) {

      return (
        enquiry
          ?.parsedBody
          ?.clientDetails
          ?.companyName ||
        '-'
      );
    }

    return (
      enquiry
        ?.parsedBody
        ?.primaryCourse
        ?.courseTitle ||
      '-'
    );
  }


  // Get requested by name
  getRequestedBy(
    enquiry: any
  ): string {

    const clientType =
      this.getClientType(
        enquiry
      );

    if (
      clientType ===
      'CORPORATE'
    ) {

      return (
        enquiry
          ?.parsedBody
          ?.clientDetails
          ?.requestedBy ||

        enquiry
          ?.sentBy ||

        '-'
      );
    }

    const givenName =
      enquiry
        ?.parsedBody
        ?.participant
        ?.givenName ||
      '';

    const familyName =
      enquiry
        ?.parsedBody
        ?.participant
        ?.familyName ||
      '';

    const fullName =
      `${givenName} ${familyName}`
        .trim();

    return (
      fullName ||
      enquiry?.sentBy ||
      '-'
    );
  }


  // Get requested by contact
  getRequestedByPhone(
    enquiry: any
  ): string {

    const clientType =
      this.getClientType(
        enquiry
      );

    if (
      clientType ===
      'CORPORATE'
    ) {

      return (
        enquiry
          ?.parsedBody
          ?.clientDetails
          ?.requestedByPhone ||
        '-'
      );
    }

    return (
      enquiry
        ?.parsedBody
        ?.participant
        ?.email ||

      enquiry
        ?.sentBy ||

      '-'
    );
  }


  // Get site location
  getSiteLocation(
    enquiry: any
  ): string {

    const clientType =
      this.getClientType(
        enquiry
      );

    if (
      clientType ===
      'CORPORATE'
    ) {

      return (
        enquiry
          ?.parsedBody
          ?.clientDetails
          ?.siteLocationAddress ||
        '-'
      );
    }

    return (
      enquiry
        ?.parsedBody
        ?.primaryCourse
        ?.occurrence
        ?.location ||
      '-'
    );
  }


  // Get training date
  getTrainingDate(
    enquiry: any
  ): any {

    const clientType =
      this.getClientType(
        enquiry
      );

    if (
      clientType ===
      'CORPORATE'
    ) {

      return (
        enquiry
          ?.parsedBody
          ?.clientDetails
          ?.dateTrainingRequired ||
        null
      );
    }

    return (
      enquiry
        ?.parsedBody
        ?.primaryCourse
        ?.occurrence
        ?.startDate ||
      null
    );
  }


  // Get participant count
  getParticipantCount(
    enquiry: any
  ): number {

    const clientType =
      this.getClientType(
        enquiry
      );

    if (
      clientType ===
      'CORPORATE'
    ) {

      return (
        enquiry
          ?.parsedBody
          ?.participants
          ?.length ||
        0
      );
    }

    return (
      enquiry
        ?.parsedBody
        ?.participant
        ? 1
        : 0
    );
  }


  // Get total UOC courses
  getTotalUOC(
    enquiry: any
  ): number {

    const clientType =
      this.getClientType(
        enquiry
      );

    if (
      clientType ===
      'GENERAL'
    ) {

      const primaryCourseCount =
        enquiry
          ?.parsedBody
          ?.primaryCourse
          ?.courseId
          ? 1
          : 0;

      const additionalCount =
        enquiry
          ?.parsedBody
          ?.additionalUOCCourses
          ?.length ||
        0;

      return (
        primaryCourseCount +
        additionalCount
      );
    }

    const participants =
      enquiry
        ?.parsedBody
        ?.participants ||
      [];

    return participants
      .reduce(
        (
          total: number,
          participant: any
        ) => {

          return (
            total +
            (
              participant
                ?.uocCourses
                ?.length ||
              0
            )
          );
        },
        0
      );
  }


  // Get total VOC courses
  getTotalVOC(
    enquiry: any
  ): number {

    const clientType =
      this.getClientType(
        enquiry
      );

    if (
      clientType ===
      'GENERAL'
    ) {

      return (
        enquiry
          ?.parsedBody
          ?.vocCourses
          ?.length ||
        0
      );
    }

    const participants =
      enquiry
        ?.parsedBody
        ?.participants ||
      [];

    return participants
      .reduce(
        (
          total: number,
          participant: any
        ) => {

          return (
            total +
            (
              participant
                ?.vocCourses
                ?.length ||
              0
            )
          );
        },
        0
      );
  }


  // Open enquiry details
  openEnquiryDetails(
    enquiry: any
  ): void {

    this.selectedEnquiry =
      enquiry;

    this.selectedEmail = enquiry.sentBy;
    this.approvalSuccessMessage =
      '';

    this.approvalErrorMessage =
      '';

    if (
      enquiry?.parsedBody
    ) {

      this.selectedEnquiryBody = enquiry.parsedBody;

    } else {

      this.selectedEnquiryBody =
        this.parseBody(
          enquiry?.body
        );
    }

    console.log(
      'Selected Enquiry:',
      this.selectedEnquiry
    );

    console.log(
      'Selected Enquiry Body:',
      this.selectedEnquiryBody
    );

    console.log(
      'Selected Client Type:',
      this.getClientType(
        enquiry
      )
    );

    this.showDetailsModal =
      true;
  }


  // Close enquiry details
  closeEnquiryDetails(): void {
    this.editDatePopup = false;
    this.showDetailsModal =
      false;

    this.selectedEnquiry =
      null;

    this.selectedEnquiryBody =
      null;

    this.approvalSuccessMessage =
      '';

    this.approvalErrorMessage =
      '';
  }

  // Open approval confirmation popup
  openApprovalPopup(editDatePopup: boolean = false): void {

    this.editDatePopup = editDatePopup;


    this.approvalErrorMessage = '';
    this.approvalDateError = '';


    // Get current training required date
    const currentTrainingDate =
      this.selectedEnquiryBody
        ?.clientDetails
        ?.dateTrainingRequired;


    // Convert date to yyyy-MM-dd for HTML date input
    this.approvalTrainingDate =
      this.formatDateForInput(
        currentTrainingDate
      );


    this.showApprovalPopup = true;
  }

  // Convert API date to HTML date input format
  formatDateForInput(
    value: string | Date | null | undefined
  ): string {

    if (!value) {
      return '';
    }


    // API already returns yyyy-MM-dd...
    if (
      typeof value === 'string' &&
      /^\d{4}-\d{2}-\d{2}/.test(value)
    ) {

      return value.substring(
        0,
        10
      );
    }


    const date =
      new Date(value);


    if (
      isNaN(
        date.getTime()
      )
    ) {

      return '';
    }


    const year =
      date.getFullYear();

    const month =
      String(
        date.getMonth() + 1
      )
        .padStart(
          2,
          '0'
        );

    const day =
      String(
        date.getDate()
      )
        .padStart(
          2,
          '0'
        );


    return `${year}-${month}-${day}`;
  }


  // Close approval popup
  closeApprovalPopup(): void {

    if (
      this.isApprovingEnquiry
    ) {
      return;
    }


    this.showApprovalPopup = false;

    this.approvalTrainingDate = '';

    this.approvalDateError = '';

    this.approvalErrorMessage = '';
  }

  // Validate date before approving
  confirmApproval(): void {

    this.approvalDateError = '';
    this.approvalErrorMessage = '';


    if (
      !this.approvalTrainingDate
    ) {

      this.approvalDateError =
        'Please select the training required date.';

      return;
    }


    this.approveSelectedEnquiry();
  }

  // Approve selected enquiry
  approveSelectedEnquiry(): void {

    if (
      !this.selectedEnquiry
    ) {

      return;
    }

    const reviewedBy = 1;

    if (!reviewedBy) {

      this.approvalErrorMessage = 'Logged-in user could not be identified.';

      return;
    }

    this.isApprovingEnquiry = true;

    this.approvalSuccessMessage =
      '';

    this.approvalErrorMessage =
      '';

    this.adminService.ApproveXBooking(this.selectedEnquiry.id, reviewedBy, this.approvalTrainingDate, (this.editDatePopup ? 'UPD' : 'APPROVE'))
      .subscribe({

        next: (
          response: string
        ) => {

          console.log(
            'Approve response:',
            response
          );

          this.isApprovingEnquiry =
            false;

          const result =
            Number(
              response
            );

          if (
            !isNaN(result) &&
            result > 0
          ) {

            this.approvalSuccessMessage =
              'Booking approved successfully.';


            this.selectedEnquiry.isApproved =
              true;

            this.selectedEnquiry.reviewedBy =
              reviewedBy;

            this.selectedEnquiry.reviewedDate =
              new Date();


            // Update displayed date locally
            if (
              this.selectedEnquiryBody
                ?.clientDetails
            ) {

              this.selectedEnquiryBody
                .clientDetails
                .dateTrainingRequired =
                this.approvalTrainingDate;
            }


            this.showApprovalPopup =
              false;


            this.loadEnquiries();


            setTimeout(
              () => {

                this.closeEnquiryDetails();

              },
              1000
            );

            return;
          }

          this.approvalErrorMessage =
            'Unable to approve enquiry.';
        },

        error: (error) => {

          console.error(
            'Approve enquiry error:',
            error
          );

          this.isApprovingEnquiry =
            false;

          this.approvalSuccessMessage =
            '';

          this.approvalErrorMessage =
            typeof error?.error ===
              'string'
              ? error.error
              : 'Unable to approve enquiry.';
        }
      });
  }


  // Open registration details
  // Open registration details
  openRegistrationDetails(
    enquiry: any
  ): void {

    const registrationBody =
      enquiry
        ?.parsedRegistrationBody
      ||
      this.parseBody(
        enquiry?.registrationBody
      );


    if (!registrationBody) {
      return;
    }


    this.selectedRegistrationEnquiry =
      enquiry;


    this.selectedRegistration =
      registrationBody;


    this.showRegistrationModal =
      true;


    this.selectedEmail =
      enquiry.sentBy;
  }

  // Close registration details
  // Close registration details
  closeRegistrationDetails(): void {

    this.showRegistrationModal =
      false;


    this.selectedRegistration =
      null;


    this.selectedRegistrationEnquiry =
      null;


    this.selectedEmail =
      '';
  }


  // Get safe document URL
  getSafeDocumentUrl(
    url: string
  ): SafeResourceUrl {

    return this.sanitizer
      .bypassSecurityTrustResourceUrl(
        url
      );
  }


  // Check document is image
  isImageFile(
    fileType: string,
    fileName: string
  ): boolean {

    const type =
      (
        fileType ||
        ''
      )
        .toLowerCase();

    const name =
      (
        fileName ||
        ''
      )
        .toLowerCase();

    return (
      type.startsWith(
        'image/'
      ) ||

      name.endsWith(
        '.jpg'
      ) ||

      name.endsWith(
        '.jpeg'
      ) ||

      name.endsWith(
        '.png'
      ) ||

      name.endsWith(
        '.webp'
      )
    );
  }


  // Check document is PDF
  isPdfFile(
    fileType: string,
    fileName: string
  ): boolean {

    const type =
      (
        fileType ||
        ''
      )
        .toLowerCase();

    const name =
      (
        fileName ||
        ''
      )
        .toLowerCase();

    return (
      type ===
      'application/pdf' ||

      name.endsWith(
        '.pdf'
      )
    );
  }




  // ============================================================
  // DOCUMENT PREVIEW SETTINGS
  // ============================================================

  documentPreviewSettings = {

    certificate: {
      width: 0,
      height: 300
    },

    identity: {
      width: 0,
      height: 100
    }

  };


  // ============================================================
  // GET IMAGE PREVIEW STYLE
  // ============================================================

  getDocumentImageStyle(
    type: 'certificate' | 'identity'
  ): { [key: string]: string } {

    const settings =
      this.documentPreviewSettings[type];

    const width =
      settings.width ?? 0;

    const height =
      settings.height ?? 0;


    const style: { [key: string]: string } = {

      display: 'block',

      'object-fit': 'contain',

      // IMPORTANT:
      // Keep actual image at top-left.
      'object-position': 'left top',

      margin: '0'
    };


    // ==========================================================
    // WIDTH > 0 && HEIGHT > 0
    //
    // Fixed box.
    // Image remains proportional using object-fit.
    // ==========================================================

    if (
      width > 0 &&
      height > 0
    ) {

      style['width'] =
        `${width}px`;

      style['height'] =
        `${height}px`;

      return style;
    }


    // ==========================================================
    // WIDTH > 0 && HEIGHT = 0
    //
    // Fixed width.
    // Height automatically follows image aspect ratio.
    // ==========================================================

    if (
      width > 0 &&
      height <= 0
    ) {

      style['width'] =
        `${width}px`;

      style['height'] =
        'auto';

      return style;
    }


    // ==========================================================
    // WIDTH = 0 && HEIGHT > 0
    //
    // Fixed height.
    // Width automatically follows image aspect ratio.
    // ==========================================================

    if (
      width <= 0 &&
      height > 0
    ) {

      style['width'] =
        'auto';

      style['height'] =
        `${height}px`;

      return style;
    }


    // ==========================================================
    // WIDTH = 0 && HEIGHT = 0
    //
    // Full available width.
    // Automatic height.
    // ==========================================================

    style['width'] =
      '100%';

    style['height'] =
      'auto';

    return style;
  }


  // ============================================================
  // GET PDF PREVIEW STYLE
  // ============================================================

  getDocumentPdfStyle(
    type: 'certificate' | 'identity'
  ): { [key: string]: string } {

    const settings =
      this.documentPreviewSettings[type];

    const width =
      settings.width ?? 0;

    const height =
      settings.height ?? 0;


    return {

      display: 'block',

      width:
        width > 0
          ? `${width}px`
          : '100%',

      height:
        height > 0
          ? `${height}px`
          : '600px',

      border: '0',

      margin: '0'
    };
  }


  isSignatureImage(
    signature: string | null | undefined
  ): boolean {

    if (!signature) {
      return false;
    }


    return (
      signature.startsWith(
        'data:image/'
      ) ||
      signature.startsWith(
        'http://'
      ) ||
      signature.startsWith(
        'https://'
      )
    );

  }


  getIdentityTypeLabel(idType: string | null | undefined): string {

    switch (idType) {

      case 'DRIVER_LICENCE':
        return 'Driver Licence';

      case 'PASSPORT':
        return 'Passport';

      case 'PROOF_OF_AGE':
        return 'Proof of Age';

      case 'OTHER':
        return 'Other';

      default:
        return idType || '-';
    }
  }


  // Check participant has VOC courses only
  isVocOnlyParticipant(
    participant: any
  ): boolean {

    const selectedCourses =
      participant?.selectedCourses || [];


    // Preferred structure
    if (
      Array.isArray(selectedCourses) &&
      selectedCourses.length > 0
    ) {

      return selectedCourses.every(
        (course: any) =>
          (
            course?.courseType || ''
          )
            .toString()
            .trim()
            .toUpperCase() ===
          'VOC'
      );
    }


    // Fallback structure
    const vocCourses =
      participant?.vocCourses || [];

    const uocCourses =
      participant?.uocCourses || [];

    const coaCourses =
      participant?.coaCourses || [];


    return (
      vocCourses.length > 0
      &&
      uocCourses.length === 0
      &&
      coaCourses.length === 0
    );
  }


  
// ============================================================
// PAGINATION
// ============================================================

// Total number of pages
get totalPages(): number {

  return Math.max(
    1,
    Math.ceil(
      this.totalRecords / this.pageSize
    )
  );

}


// Page numbers
get pageNumbers(): number[] {

  return Array.from(
    { length: this.totalPages },
    (_, index) => index + 1
  );

}


// First displayed record
get startRecord(): number {

  if (this.totalRecords === 0) {
    return 0;
  }

  return this.firstRecord + 1;

}


// Last displayed record
get endRecord(): number {

  if (this.totalRecords === 0) {
    return 0;
  }

  return Math.min(
    this.firstRecord + this.enquiries.length,
    this.totalRecords
  );

}


// Change page
changePage(page: number): void {

  if (
    !Number.isInteger(page) ||
    page < 1 ||
    page > this.totalPages ||
    this.isLoading
  ) {
    return;
  }

  if (this.pageNo === page) {
    return;
  }

  this.pageNo = page;

  this.firstRecord =
    (this.pageNo - 1) * this.pageSize;

  this.loadEnquiries();

}


// Previous page
previousPage(): void {

  this.changePage(
    this.pageNo - 1
  );

}


// Next page
nextPage(): void {

  this.changePage(
    this.pageNo + 1
  );

}


// Change rows per page
onPageSizeChange(): void {

  this.pageNo = 1;

  this.firstRecord = 0;

  this.loadEnquiries();

}

}


